import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse
} from '@angular/common/http';

import { EMPTY, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { retry, catchError } from 'rxjs/operators';
import { Messages } from '../constants/Messages';
import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { ToastService } from 'app/services/toast.service';
// import { StorageUtil } from 'src/app/utilities/storage.util';


@Injectable()
/**
 * This class is of category http interceptor. It intercepts all the received service response and checks for error status.
 * If it's error response, it displays the respective message for the user. Else, pushes the success to the requesting service as it is.
 *
 * If we create any service in the future, this interceptor will automatically be implemented.
 */
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(private router: Router,
        private toastService: ToastService 
    ) {
        }

    // Main interceptor function which parses the response.
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
        .pipe(
            retry(1), // if the request failes, it retries one more before deferring as error.
            catchError((error: HttpErrorResponse) => {
            if (error.error instanceof ErrorEvent) {
                this.clientSideError();
            } else {
                this.responseError(error.status, error.error.message);
            }
            return EMPTY; // Returns nothing to console
            })
        );
    }

    /**
     * This method is called when there is error from client side example internet failure and respective message is shown to the user.
     */
     clientSideError() {
    //    this.toastService.openToast(Messages.local.serviceCallFail);
    }

    /**
     * This method takes the error code as parameter and displays the matching messages.
     * @param errorCode | Number
     * @param errorMessage | String
     * @returns | None
     */
    responseError(errorCode: number,errorMessage: string) {
        let serviceErrorMessage = '';
        if (errorCode == 0) {
            serviceErrorMessage = Messages.service.errorCode0;
        }

        if (errorCode == 400) {
            serviceErrorMessage = Messages.service.errorCode400;
        }

        if (errorCode == 401) {
            // Handle JWT token expiration
            console.log('401 Unauthorized - Token expired or invalid');

            // Clear all authentication data
            Preferences.clear();
            localStorage.removeItem('accessToken');

            // Check if the error message indicates JWT expiration
            if (errorMessage && errorMessage.includes('JWT token is expired')) {
                serviceErrorMessage = 'Your session has expired. Please sign in again.';
                this.toastService.showError('Session expired. Redirecting to login...');
            } else {
                serviceErrorMessage = Messages.service.errorCode401;
                this.toastService.showError('Authentication failed. Please sign in again.');
            }

            // Redirect to sign-in page with current URL for redirect after login
            const currentUrl = this.router.url;
            if (!currentUrl.startsWith('/sign-in') && !currentUrl.startsWith('/sign-out')) {
                setTimeout(() => {
                    this.router.navigate(['/sign-in'], {
                        queryParams: {
                            // Pass the raw URL — Angular encodes query params itself.
                            // Pre-encoding here produced double-encoded values like
                            // redirectURL=%252Fsign-out that broke post-login navigation.
                            redirectURL: currentUrl,
                            reason: 'expired'
                        }
                    });
                }, 1000); // Small delay to show the error message
            }
        }

        if (errorCode == 404) {
            serviceErrorMessage = Messages.service.errorCode404;
        }

        if (errorCode == 413) {
            serviceErrorMessage = Messages.service.errorCode413;
        }

        if (errorCode == 500) {
            serviceErrorMessage = Messages.service.errorCode500;
        }
        console.log(errorMessage);
        if(errorMessage !== undefined){
            this.toastService.showError(errorMessage ?? serviceErrorMessage);
        }else{
            this.toastService.showError(serviceErrorMessage);
        }
    }
}
